import kushal from "./kushalgupta.jpg";
import achal from "./achal.jpg";
import ninad from "./ninad.jpg";
import divit from "./divit.jpg";
import luthra from "./luthra.jpeg";
import siddharth from "./siddharth.jpeg";
import rick from "./rick.jpg";
import hriday from "./hriday.jpg";
import jasraj from "./jasraj.png";
import aadi from "./aadi.webp";
import aakrit from "./aakrit.jpeg";
import akshat from "./akshat.jpeg";
import srinath from "./srinath.jpg";
import anshita from "./anshita.jpeg";
import kamra from "./kamra.jpg";
import sujal from "./sujal.jpg";
import risabh from "./risabh.jpg";
import nysa from "./nysa.jpg";
import vishal from "./vishal.jpeg";
import swayam from "./swayam.jpg";
import shivansh from "./shivansh.png";
import dhruv from "./dhruv.jpg";
import amay from "./amay.jpg";
import stuti from "./stuti.jpg";
const members = [
  {
    name: "Kushal Gupta",
    id: "2022A8PS1545H",
    photo: kushal,
    position: "Research and Content",
    linkedIn: "https://www.linkedin.com/in/kushal-gupta/",
  },
  {
    name: "Ninad Agrawal",
    id: "2021A7PS2948H",
    photo: ninad,
    position: "Developer",
    linkedIn: "https://www.linkedin.com/in/ninad-agrawal-67808b238/",
  },
  {
    name: "Achal Jhawar",
    id: "2023A3CP2163H",
    photo: achal,
    position: "Developer",
    linkedIn: "https://www.linkedin.com/in/achal-jhawar/",
  },
  {
    name: "Divit Setia",
    id: "2023B3PS0477H",
    photo: divit,
    position: "Research and Content",
    linkedIn: "https://www.linkedin.com/in/divit-setia-bphc/",
  },
  {
    name: "Dhairya Luthra",
    id: "2022A7PS1377H",
    photo: luthra,
    position: "Developer",
    linkedIn: "https://www.linkedin.com/in/dhairya-luthra-a8b876210/",
  },
  {
    name: "Siddharth Singh",
    id: "2023A4PS1353H",
    photo: siddharth,
    position: "Research and Content",
    linkedIn: "https://www.linkedin.com/in/siddharth-singh-135974221/",
  },
  {
    name: "Rickpoul Ghosh ",
    id: "2022AAPS1549H",
    photo: rick,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/feed/?trk=guest_homepage-basic_google-one-tap-submit",
  },
  {
    name: "Hriday Bhuta",
    id: "2023A2PS0901H",
    photo: hriday,
    position: "Logistics",
    linkedIn: "https://www.linkedin.com/in/hriday-bhuta-32a74b285/",
  },
  {
    name: "Jasraj Singh Seth",
    id: "2023B3PS1077H",
    photo: jasraj,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/feed/?trk=guest_homepage-basic_google-one-tap-submit",
  },
  {
    name: "Aadi Deshmukh",
    id: "2023A7PS0094H",
    photo: aadi,
    position: "Logistics",
    linkedIn: "https://www.linkedin.com/in/aadi-deshmukh-a3341028b/",
  },
  {
    name: "Aakrit Jain",
    id: "2023A4PS0614H",
    photo: aakrit,
    position: "Developer",
    linkedIn: "https://www.linkedin.com/in/aakrit-jain-054a282b2/",
  },
  {
    name: "Akshat Bhaskar",
    id: "2023A4PS1352H",
    photo: akshat,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/in/akshat-bhaskar-71344a285?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Srinath Murali",
    id: "2022B3A70594H",
    photo: srinath,
    position: "Developer",
    linkedIn: "https://www.linkedin.com/in/srinathmurali31/",
  },
  {
    name: "Anshita Pandey",
    id: "2023A2PS1223H",
    photo: anshita,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/in/anshita-pandey-a989b424b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  },
  {
    name: "Siddhant Kamra",
    id: "2022A7PS0202H",
    photo: kamra,
    position: "Research and Content",
    linkedIn: "https://www.linkedin.com/in/siddhant-kamra-0a144927b/",
  },
  {
    name: "Sujal Chopra",
    id: "2023A5PS1031H",
    photo: sujal,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/in/sujal-chopra-760ba72a5?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Rishabh Singh",
    id: "2023B4PS0721H",
    photo: risabh,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/in/rishabh-singh-67b510286?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Nysa Charan Pahari",
    id: "2023A3PS0350H",
    photo: nysa,
    position: "Developer",
    linkedIn: "https://www.linkedin.com/in/nysa-c-pahari-333265287/",
  },
  {
    name: "Vishal Goel",
    id: "2023A7PS1108H",
    photo: vishal,
    position: "Research and Content",
    linkedIn:
      "https://www.linkedin.com/in/vishal-goel-16b6732a1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  },
  {
    name: "Swayam Shree",
    id: "2023A3PS0354H",
    photo: swayam,
    position: "Developer",
    linkedIn:
      "https://www.linkedin.com/in/swayam-shree-b594aa291?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    name: "Shivansh",
    id: "2022B1AA1227H",
    photo: shivansh,
    position: "Developer",
    linkedIn:
      "https://www.linkedin.com/in/kumar-shivansh-sinha-6a807324b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Dhruv Singh",
    id: "2022A4PS1399H",
    photo: dhruv,
    position: "Research and Content",
    linkedIn: "https://www.linkedin.com/in/dhruv-singh-9910a925b/",
  },
  {
    name: "Amay Deodhar",
    id: "2023A7PS0155H",
    photo: amay,
    position: "Logistics",
    linkedIn:
      "https://www.linkedin.com/in/amay-deodhar-095539284?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Stuti Nagar",
    id: "2023A5PS1048H",
    photo: stuti,
    position: "Research and Content",
    linkedIn: "https://www.linkedin.com/in/stuti-n-791b88206",
  },
];

export default members;
